module.exports = __webpack_public_path__ + "img/calearna-icon-16x16.7e8b62d6.png";